// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'core-js';
import 'regenerator-runtime/runtime';

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import { Button, Dialog, RadioGroup, Radio } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'es5-shim';
import 'es6-shim';
import { createAudio } from '@/plugins/voice_tts.js'
import returnResult from '@/interface/controller.js'
import { Message } from '@/components/message/message.js'
import { cookieSet, testIsStop, isRouterToSpcanning } from './plugins/tool'


// router.beforeEach((to, from, next) => {
//   let autoExam = cookieSet.getCookie('autoExam');
//   console.log(autoExam);
//   if (autoExam != '' || autoExam != null || autoExam != undefined) {
//     next()
//   } else {
//     next({ path: "/login", replace: true })
//   }
// })





Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Dialog)
Vue.use(RadioGroup)
Vue.use(Radio)

Vue.use(ElementUI)
Vue.prototype.$createAudio = createAudio;
Vue.prototype.$returnResult = returnResult;
Vue.prototype.$message = Message;
Vue.prototype.$ws = 'wss://rtk-exam.3wchina.net/ws';
//Vue.prototype.$ws = 'ws://student.exam.aopa.org.cn:9080/ws';
//Vue.prototype.$ws = 'ws://exam-info.166.com:9080/ws';
Vue.prototype.$wws = 'ws:127.0.0.1:8800';
Vue.prototype.$cookieSet = cookieSet;
Vue.prototype.$testIsStop = testIsStop;
Vue.prototype.$isRouterToSpcanning = isRouterToSpcanning;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

